import { Resources } from "./Resources";

export const ParentsResources = () => {
  return (
    <Resources blog_type="parents" />
  );
};
